import MapMarkers from './MapMarkers'

export default MapMarkers
